import React from 'react'
import PropTypes from 'prop-types'

const PATH_D = 'M10.4167 9.16667H9.75833L9.525 8.94167C10.3417 7.99167 10.8333 6.75833 10.8333 5.41667'
  + 'C10.8333 2.425 8.40833 0 5.41667 0C2.425 0 0 2.425 0 5.41667C0 8.40833 2.425 10.8333 5.41667 10.8333'
  + 'C6.75833 10.8333 7.99167 10.3417 8.94167 9.525L9.16667 9.75833V10.4167L13.3333 14.575L14.575 13.3333'
  + 'L10.4167 9.16667ZM5.41667 9.16667C3.34167 9.16667 1.66667 7.49167 1.66667 5.41667'
  + 'C1.66667 3.34167 3.34167 1.66667 5.41667 1.66667C7.49167 1.66667 9.16667 3.34167 9.16667 5.41667'
  + 'C9.16667 7.49167 7.49167 9.16667 5.41667 9.16667Z'

const SearchIcon = ({ className }) => (
  <svg
    aria-hidden="true"
    className={className}
    fill="none"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d={PATH_D} fill="currentColor" transform="translate(2.7125 2.7125)" />
  </svg>
)

SearchIcon.propTypes = {
  className: PropTypes.string
}

SearchIcon.defaultProps = {
  className: 'tw:h-5 tw:w-5'
}

export default SearchIcon
